import useApiQueryData from "../use_api_query_data";
import { API_STATES_BACKEND } from "../../api";
import XNGApiQueryParamObject from "../../../types/xng_api_query_param_object";

type Data = Awaited<ReturnType<typeof API_STATES_BACKEND.getStates>>;

/**
 * States a user can request access in — step one of the registration cascade.
 *
 * Only states with an account behind them come back, so every option leads somewhere. Deliberately
 * takes no client id: the caller is mid-onboarding and has no client yet.
 */
const useApiQueryGetStates = (options?: XNGApiQueryParamObject<never, Data>["options"]) => {
  return useApiQueryData({
    queryFn: async () => await API_STATES_BACKEND.getStates(),
    queryKey: ["getStates"],
    staleTime: 1000 * 60 * 60 * 5, // 5 hours — the set changes when we sign a new state
    ...(options ?? {}),
  });
};

export default useApiQueryGetStates;
